import { createContext } from 'react';
import type { BreadcrumbsContextType } from './types';

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(
  null
);
